export const OBJECT_TYPE_PAGE_SLUG_CONFIGS = [
  {
    slug: 'hotel-complexes',
    filtersState: {
      object_type: ['hotel-complex'],
    },
    dictKey: 'hotel-complex',
  },
  {
    slug: 'residential-complexes',
    filtersState: {
      object_type: ['residential-complex'],
    },
    dictKey: 'residential-complex',
  },
  {
    slug: 'apartments',
    filtersState: {
      object_type: ['apartments'],
    },
    dictKey: 'apartments',
  },
  {
    slug: 'villas',
    filtersState: {
      object_type: ['villa'],
    },
    dictKey: 'villa',
  },
  {
    slug: 'hotels',
    filtersState: {
      object_type: ['hotel'],
    },
    dictKey: 'hotel',
  },
  {
    slug: 'houses',
    filtersState: {
      object_type: ['house'],
    },
    dictKey: 'house',
  },
  {
    slug: 'maisonettes',
    filtersState: {
      object_type: ['maisonette'],
    },
    dictKey: 'maisonette',
  },
  {
    slug: 'flats',
    filtersState: {
      object_type: ['flat'],
    },
    dictKey: 'flat',
  },
  {
    slug: 'duplexes',
    filtersState: {
      object_type: ['duplex'],
    },
    dictKey: 'duplex',
  },
  {
    slug: 'chaletes',
    filtersState: {
      object_type: ['chalet'],
    },
    dictKey: 'chalet',
  },
  {
    slug: 'offices',
    filtersState: {
      object_type: ['office'],
    },
    dictKey: 'office',
  },
  {
    slug: 'parkings',
    filtersState: {
      object_type: ['parking'],
    },
    dictKey: 'parking',
  },
  {
    slug: 'yacht-berths',
    filtersState: {
      object_type: ['yacht-berth'],
    },
    dictKey: 'yacht-berth',
  },
  {
    slug: 'penthouses',
    filtersState: {
      object_type: ['penthouse'],
    },
    dictKey: 'penthouse',
  },
  {
    slug: 'free-purposes',
    filtersState: {
      object_type: ['free-purpose'],
    },
    dictKey: 'free-purpose',
  },
  {
    slug: 'retail',
    filtersState: {
      object_type: ['retail'],
    },
    dictKey: 'retail',
  },
  {
    slug: 'townhouses',
    filtersState: {
      object_type: ['townhouse'],
    },
    dictKey: 'townhouse',
  },

  {
    slug: 'plots',
    filtersState: {
      object_type: ['plot'],
    },
    dictKey: 'plot',
  },
  {
    slug: 'shares',
    filtersState: {
      object_type: ['share'],
    },
    dictKey: 'share',
  },
  {
    slug: 'bungalows',
    filtersState: {
      object_type: ['bungalow'],
    },
    dictKey: 'bungalow',
  },
  {
    slug: 'commercial',
    filtersState: {
      object_type: ['retail', 'hotel'],
    },
    dictKey: 'commercial',
  },
] as const;

export const OBJECT_STAGE_PAGE_SLUG_CONFIGS = [
  {
    slug: 'under-construction',
    filtersState: { object_stage: 'construction' },
    dictKey: '',
  },
] as const;
